/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: nJ1Nn58LcfAm7wemZm71QH
// Component: lr2_tnSk7cps
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/projectcss
import sty from "./PlasmicButtonSecondary.module.css"; // plasmic-import: lr2_tnSk7cps/css

createPlasmicElementProxy;

export const PlasmicButtonSecondary__VariantProps = new Array("color");

export const PlasmicButtonSecondary__ArgProps = new Array(
  "onClick",
  "disabled",
  "name",
  "content",
  "windowId"
);

const $$ = {};

function PlasmicButtonSecondary__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          disabled: false,
          content: "link button"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.color
      }
    ],

    [$props, $ctx, $refs]
  );
  const currentUser = useCurrentUser?.() || {};
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"wrapp"}
      data-plasmic-override={overrides.wrapp}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_nJ1Nn58LcfAm7wemZm71QH",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.wrapp,
        {
          [sty.wrappcolor_primaryBrand]: hasVariant(
            $state,
            "color",
            "primaryBrand"
          ),
          [sty.wrappcolor_primaryGrey]: hasVariant(
            $state,
            "color",
            "primaryGrey"
          ),
          [sty.wrappcolor_secondary]: hasVariant($state, "color", "secondary"),
          [sty.wrappcolor_tertiary]: hasVariant($state, "color", "tertiary")
        }
      )}
    >
      <div
        className={classNames("all", "__wab_text", sty.text__jJpxM, {
          [sty.textcolor_primaryBrand__jJpxM775B4]: hasVariant(
            $state,
            "color",
            "primaryBrand"
          ),
          [sty.textcolor_primaryGrey__jJpxMepc3V]: hasVariant(
            $state,
            "color",
            "primaryGrey"
          ),
          [sty.textcolor_primaryLight__jJpxMixMaB]: hasVariant(
            $state,
            "color",
            "primaryLight"
          ),
          [sty.textcolor_primary__jJpxMtaDPi]: hasVariant(
            $state,
            "color",
            "primary"
          ),
          [sty.textcolor_secondary__jJpxMmIiPk]: hasVariant(
            $state,
            "color",
            "secondary"
          ),
          [sty.textcolor_tertiary__jJpxMUmbfP]: hasVariant(
            $state,
            "color",
            "tertiary"
          )
        })}
      >
        {"["}
      </div>
      <PlasmicLink__
        data-plasmic-name={"link"}
        data-plasmic-override={overrides.link}
        className={classNames("all", "a", "a__nJ1Nn", "__wab_text", sty.link, {
          [sty.linkcolor_primaryBrand]: hasVariant(
            $state,
            "color",
            "primaryBrand"
          ),
          [sty.linkcolor_primaryGrey]: hasVariant(
            $state,
            "color",
            "primaryGrey"
          ),
          [sty.linkcolor_primaryLight]: hasVariant(
            $state,
            "color",
            "primaryLight"
          ),
          [sty.linkcolor_primary]: hasVariant($state, "color", "primary"),
          [sty.linkcolor_secondary]: hasVariant($state, "color", "secondary"),
          [sty.linkcolor_tertiary]: hasVariant($state, "color", "tertiary")
        })}
        disabled={(() => {
          try {
            return $props.disabled;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
        name={(() => {
          try {
            return $props.name;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
        onClick={async event => {
          const $steps = {};
          $steps["runOnClick"] = true
            ? (() => {
                const actionArgs = { eventRef: $props["onClick"] };
                return (({ eventRef, args }) => {
                  return eventRef?.(...(args ?? []));
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["runOnClick"] != null &&
            typeof $steps["runOnClick"] === "object" &&
            typeof $steps["runOnClick"].then === "function"
          ) {
            $steps["runOnClick"] = await $steps["runOnClick"];
          }
        }}
        platform={"react"}
      >
        <React.Fragment>
          {(() => {
            try {
              return $props.content;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return "continue";
              }
              throw e;
            }
          })()}
        </React.Fragment>
      </PlasmicLink__>
      <div
        className={classNames("all", "__wab_text", sty.text__nTamh, {
          [sty.textcolor_primaryBrand__nTamh775B4]: hasVariant(
            $state,
            "color",
            "primaryBrand"
          ),
          [sty.textcolor_primaryGrey__nTamhepc3V]: hasVariant(
            $state,
            "color",
            "primaryGrey"
          ),
          [sty.textcolor_primaryLight__nTamhixMaB]: hasVariant(
            $state,
            "color",
            "primaryLight"
          ),
          [sty.textcolor_primary__nTamhtaDPi]: hasVariant(
            $state,
            "color",
            "primary"
          ),
          [sty.textcolor_secondary__nTamhMIiPk]: hasVariant(
            $state,
            "color",
            "secondary"
          ),
          [sty.textcolor_tertiary__nTamhUmbfP]: hasVariant(
            $state,
            "color",
            "tertiary"
          )
        })}
      >
        {"]"}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  wrapp: ["wrapp", "link"],
  link: ["link"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicButtonSecondary__ArgProps,
          internalVariantPropNames: PlasmicButtonSecondary__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButtonSecondary__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "wrapp") {
    func.displayName = "PlasmicButtonSecondary";
  } else {
    func.displayName = `PlasmicButtonSecondary.${nodeName}`;
  }
  return func;
}

export const PlasmicButtonSecondary = Object.assign(
  // Top-level PlasmicButtonSecondary renders the root element
  makeNodeComponent("wrapp"),
  {
    // Helper components rendering sub-elements
    link: makeNodeComponent("link"),
    // Metadata about props expected for PlasmicButtonSecondary
    internalVariantProps: PlasmicButtonSecondary__VariantProps,
    internalArgProps: PlasmicButtonSecondary__ArgProps
  }
);

export default PlasmicButtonSecondary;
/* prettier-ignore-end */
